import React, { useState, useEffect } from "react"
import { useIntl } from "react-intl"
import formatCurrency from "../../helpers/currencyHelper"
import { AlertError, AlertLoading } from '../../helpers/AlertHelper'

import ExpensesProjectsService from "../../services/ExpensesProjectsService"

import BarChart from "../../components/charts/BarChart"

const ExpensesProjectsReports = ({ onChangeDataset, yearFrom = null, yearTo = null, projectId = null }) => {
    const intl = useIntl()

    const [expensesProjectsDataset, setExpensesProjectsDataset] = useState(null)
    const [isLoaded, setIsLoaded] = useState(false)
    const [error, setError] = useState(null)

    // Fetch expenses projects dataset
    const fetchExpensesProjectsDataset = async () => {
        try {
            const filters = {};
            if (yearFrom) filters.yearFrom = yearFrom
            if (yearTo) filters.yearTo = yearTo
            if (projectId) filters.projectId = projectId
            const response = await ExpensesProjectsService.getExpensesProjectsDataset({ yearFrom, yearTo, projectId })

            const { labels, datasets } = response.data.dataset

            // Construcción del dataset directamente al obtener los datos
            const formattedDataset = {
                labels,
                datasets: [
                    {
                        label: intl.formatMessage({ id: "expensesTotalAmount", defaultMessage: "Total amount" }),
                        data: datasets[0].data,
                        yAxisID: "y",
                        borderColor: "rgb(53, 162, 235)",
                        backgroundColor: "rgba(53, 162, 235, 0.5)",
                        datalabels: {
                            anchor: 'end',
                            align: 'end',
                            color: '#333',
                            rotation: -45,
                            font: {
                                weight: 'bold',
                                size: 12
                            },
                            formatter: value => formatCurrency(value),
                        },
                    },
                ],
            }

            setExpensesProjectsDataset(formattedDataset)
            onChangeDataset({
                ...formattedDataset,
                datasets: [formattedDataset.datasets[0]],
                totalAmountsSum: response.data.dataset.totalAmountsSum,
                totalExpensesProjectsSum: response.data.dataset.totalExpensesProjectsSum
            })
            setIsLoaded(true)
        } catch (err) {
            setIsLoaded(false)
            setError(err)
        }
    }

    // Re-fetch data on page/perPage change
    useEffect(() => {
        fetchExpensesProjectsDataset()
    }, [yearFrom, yearTo, projectId])

    return (
        <>
            {error && <AlertError error={error} />}
            {!isLoaded && <AlertLoading isLoaded={isLoaded} />}
            {isLoaded && (
                <BarChart
                    data={expensesProjectsDataset}
                />
            )}
        </>
    )
}

export default ExpensesProjectsReports